// InboxCounters (M1 §8): total/atrasados/por tipo — `aria-live=polite`, atualiza a cada 60s (REQ-WF-006).
// Reutilizado pelo painel e pela insígnia do InboxButton (Topbar).
import { Skeleton } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import { useInboxCounters } from '../api/queries';

export function InboxCounters() {
  const { t } = useTranslation('workflow');
  const { data, isLoading } = useInboxCounters();

  if (isLoading || !data) {
    return <Skeleton className="h-16 w-full" data-testid="inbox-counters-loading" />;
  }

  return (
    <div
      aria-live="polite"
      data-testid="inbox-counters"
      className="flex flex-col gap-2 rounded-card border p-3 text-body"
    >
      <p className="font-medium">{t('inbox.counters.total', { count: data.total })}</p>
      <p className="text-muted-foreground">
        {t('inbox.counters.overdue', { count: data.overdue })}
      </p>
      <dl className="flex flex-wrap gap-x-4 gap-y-1 text-caption text-muted-foreground">
        <div className="flex gap-1">
          <dt>{t('kinds.task')}:</dt>
          <dd data-testid="inbox-counters-task">{data.byKind.task}</dd>
        </div>
        <div className="flex gap-1">
          <dt>{t('kinds.approval')}:</dt>
          <dd data-testid="inbox-counters-approval">{data.byKind.approval}</dd>
        </div>
        <div className="flex gap-1">
          <dt>{t('kinds.exception')}:</dt>
          <dd data-testid="inbox-counters-exception">{data.byKind.exception}</dd>
        </div>
      </dl>
    </div>
  );
}
